import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Attachment } from '../../communication-attachment.component';
import { UserService } from 'src/app/core/services/user.service';
import { DocumentService } from 'src/app/core/services/base/document.service';
import { SupabaseService } from 'src/app/core/services/base/supabase.service';

@Component({
  selector: 'app-pdf-modal',
  templateUrl: './pdf-modal.component.html',
  styleUrls: ['./pdf-modal.component.scss'],
})
export class PdfModalComponent implements OnInit,OnDestroy {
  zoom: number = 0.5;
  email?:string;
  url:string = '';
  el = (event:any) =>
    event.preventDefault()
  
  constructor(
    public dialogRef: MatDialogRef<PdfModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: Attachment,
    private us: UserService,
    private sbs: SupabaseService
  ) {}



  async ngOnInit(){
    const el = document.addEventListener('contextmenu',this.el) ;
    if (!this.data.path) {
      throw new Error("Attachment does not have a path");
    }
    const user = await this.us.getCurrentUser();
    this.email = user?.primary_email;
    this.url = (await this.sbs.supabase.storage.from('claim-documents').createSignedUrl(this.data.path,60)).data?.signedUrl!;
  }

  ngOnDestroy(): void {
    document.removeEventListener('contextmenu', this.el    );
  }

  incrementZoom(amount: number) {
    this.zoom += amount;
    console.log(this.zoom);
  }
}
